// import Contact from './abc/Contact';
import './App.css';
import AllPages from './Pages/AllPages/AllPages';

function App() {
  return (
    <div className="App">
      <AllPages/>
      {/* <Contact/> */}
    </div>
  );
}

export default App;
